import React, { FC, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { uploadFile } from '../../../api/api'
import { saveCompanies } from '../../../store/pages-management/actions'

import { companyAddEmployee,
  companyDeleteEmployee,
  companyInfoUpdateName,
  companySetAvatar } from '../../../store/pages-management/actions'
import { PagesManagementStore } from '../../../store/pages-management/types'
import { Plann3rStore } from '../../../store/types'
import { ApiResponse, Company, Employee } from '../../../types/plann3r'
import { isValidEmail } from '../../../utils/general'

import './styles.scss'

const CompanySettings: FC = () => {
  const [addpeople, setaddpeople] = useState('')
  const [addpeoplerror, setaddpeoplerror] = useState('')
  const [uploadedLogo, setuploadedLogo] = useState('')
  // const [uploadingLogo, setuploadingLogo] = useState(false)

  const strings = useSelector(
    (state: Plann3rStore) => state.languages.strings.pages.companysettings,
  )

  const { companies, active_company, saving } = useSelector(
    (state: Plann3rStore): PagesManagementStore => state.pagesManagement,
  )

  const company = companies.find(
    (company: Company) => company.id === active_company,
  )

  const dispatch = useDispatch()

  const addEmployee = () => {
    if (isValidEmail(addpeople)) {
      dispatch(companyAddEmployee(addpeople))
      setaddpeople('')
      setaddpeoplerror('')
    } else {
      setaddpeoplerror(strings.invalid_email)
    }
  }

  const handleUploadFileReceived = (response: ApiResponse) => {
    if (response.success && response.url) {
      dispatch(companySetAvatar(response.url))
      setuploadedLogo(response.url)
    } else {
      alert(strings.something_went_wrong)
    }
    //setuploadingLogo(false)
  }

  const uploadLogo = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files ? e.target.files[0] : null

    if (file && file.name.match(/.(jpg|jpeg|png|gif)$/i)) {
      if (file.size < 2000000) {
        handleUploadFileReceived(await uploadFile(file, 'plann3r-company-logos'))

        //setuploadingLogo(true)
      } else {
        alert(strings.file_too_big)
        //setuploadingLogo(false)
      }
    } else {
      alert(strings.unsupported_extension)
      //setuploadingLogo(false)
    }
  }

  const renderEmployee = (employee: Employee, canDelete: boolean) => {
    const label =
      (employee.first_name === '' || employee.first_name === null) &&
      (employee.last_name === '' || employee.last_name === null)
        ? employee.email
        : employee.first_name + ' ' + employee.last_name
    return (
      <div className="employee_card" key={employee.id}>
        <img src={employee.avatar} alt={label} />
        <span className="blue">{label}</span>
        {canDelete && (
          <button
            className="dragleft button"
            onClick={() => {
              dispatch(companyDeleteEmployee(employee.id))
            }}
          >
            {strings.delete}
          </button>
        )}
      </div>
    )
  }

  if (!company) return <div></div>

  let logo
  if (uploadedLogo) {
    logo = uploadedLogo
  } else if (company.avatar) {
    logo = company.avatar
  } else {
    logo =
      'https://s3-us-west-2.amazonaws.com/plann3r.profilepictures/default.png'
  }

  return (
    <div className="companysettings">
      {company.not_saved && !saving && (
        <div className="save_box has-blue-background is-white">
          <div className="align_box">
            {!saving && <span>{strings.unsaved_changes}</span>}
            {saving && <span>{strings.saving_changes}</span>}
            <button
              className="button is-secondary"
              onClick={() => {
                dispatch(saveCompanies(companies))
              }}
            >
              {strings.save_changes}
            </button>
          </div>
        </div>
      )}
      <div className="part logo">
        <h3 className="part_header">{strings.company_logo}</h3>
        <div>
          <div>
            <img alt={company.name} src={logo} />
            <input type="file" id="uploadlogo" hidden onChange={uploadLogo} />
          </div>
          <div>
            <button
              className="button is-primary"
              onClick={() => {
                document.getElementById('uploadlogo')?.click()
              }}
            >
              {strings.choose_file}
            </button>
            <br />
            <span>{strings.best_image}</span>
          </div>
        </div>
      </div>
      <hr />
      <div className="part head company_name">
        <h3 className="part_header">{strings.company_name}</h3>
        <div>
          <input
            type="text"
            className="grey full-width"
            value={company.name}
            placeholder="Tesla"
            onChange={(event) => {
              let valid_url_chars =
                'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789\\-\\._~:/?#[]@!$\'()*+,;='
              valid_url_chars = valid_url_chars.replace(
                /[.*+?^${}()|[\]\\]/g,
                '\\$&',
              )
              if (event.target.value.match('[^' + valid_url_chars + ']')) {
                alert(strings.cannot_contain)
              } else {
                dispatch(companyInfoUpdateName(event.target.value))
              }
            }}
            required
          />
        </div>
        <div>
          <span>{strings.change_alert}</span>
        </div>
      </div>
      <hr />
      <div className="employees detailbox">
        <h3 className="_h3">{strings.employees}</h3>
        <div className="employee_cards">
          {company.employees.map((employee) =>
            renderEmployee(employee, company.employees.length > 1),
          )}
        </div>
        <div>
          <input
            id="last_name"
            className="grey"
            type="text"
            value={addpeople}
            onChange={(event) => setaddpeople(event.target.value)}
            placeholder={
              strings.someone +
              '@' +
              company.name.replace(' ', '').toLowerCase() +
              '.com'
            }
          />
          <button
            className="button is-primary add_employee"
            onClick={addEmployee}
          >
            {strings.add_employee}
          </button>
        </div>
        <span className="red">{addpeoplerror}</span>
      </div>
    </div>
  )
}

export default CompanySettings
